import { z } from "zod";

import { type DeliveryDisputeTopic } from "../OfferCard/interfaces";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export const DISPUTE_TOPICS: DeliveryDisputeTopic[] = ["QUANTITY", "PAYMENT"];

export const MAX_DISPUTE_COMMENT_LENGTH = 1000;

export interface DisputeDeliveryValues {
  topics: DeliveryDisputeTopic[];
  comment: string;
}

export const createDisputeDeliverySchema = (t: TranslateFn) =>
  z.object({
    topics: z
      .array(z.enum(["QUANTITY", "PAYMENT"]))
      .min(1, t("disputeDeliveryModal.topicsRequired")),
    comment: z
      .string()
      .trim()
      .min(1, t("traderDetails.form.mandatoryFieldBlankError"))
      .max(MAX_DISPUTE_COMMENT_LENGTH, t("disputeDeliveryModal.commentTooLong")),
  });
